import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import AthleteDashboard from "./AthleteDashboard";
import FanDashboard from "./FanDashboard";

const Dashboard = () => {
  const { user, isAthlete, isAdmin, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/auth?next=/dashboard" replace />;
  if (isAthlete || isAdmin) return <AthleteDashboard />;
  return <FanDashboard />;
};

export default Dashboard;
